




























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  confirmDeletion,
  DateHelpers,
  GlobalHelper,
} from "@/helper/global-helper";
import { ErrorBag, Validator } from "vee-validate";
import { PageStore, PageStores } from "@/store/modules/page-store";
import Spinner from "@/components/Spinner.vue";
import TOMFragebogen from "../TOMFragebogen";
import { UserModule, UserStore } from "@/store/modules/currentuser-store";
//@ts-ignore
import * as pickerlanguages from "vuejs-datepicker/dist/locale/index.js";
import { DateTime } from "luxon";
import { DokumentService } from "@/services/dokument-service";
import TOMFragebogenAuswahl from "./TOMFragebogen-Auswahl.vue";
import refreshFragebogen from "../logic/refreshFragebogen";
import EditPageBase from "@/views/Generic/EditPageBase.vue";

@Component({
  components: {
    Spinner,
    TOMFragebogenAuswahl,
  },
})
export default class TOMFragebogenAufstellungNeu extends EditPageBase {
  public tomfApi = new TOMFragebogen.API();
  public errors!: ErrorBag;

  private isDirty: boolean = true;

  public isLoading: boolean = true;
  public aufstellung!: TOMFragebogen.TOMAufstellung.Neu;
  public fakeFragebogen!: TOMFragebogen;

  public erstellungDatum!: Date;

  public isDisabled: boolean = false;
  public isSending: boolean = false;
  public hasTriedSaving: boolean = false;
  public isDisplayingFragebogen: boolean = false;

  public isUpdating: boolean = false;
  public aufgeklappteIds: string[] = [];

  get isMissingBausteine() {
    return this.fakeFragebogen.TomBausteine.every(
      (c) => c.IstAusgewaehlt === false || c.IstAusgewaehlt === undefined
    );
  }

  public async speichernUndKlappen(
    baustein: TOMFragebogen.Baustein,
    elternteil: TOMFragebogen.Baustein
  ) {
    try {
      baustein[TOMFragebogen.Baustein.Symbols.istAngepasst] = true;
      this.onKlappen(baustein);
      await this.save(false);
    } catch (error) {
      baustein[TOMFragebogen.Baustein.Symbols.istAngepasst] = false;
      this.onKlappen(baustein);
    } finally {
      refreshFragebogen(this.fakeFragebogen);
    }
  }

  public klappeBausteinZu(baustein: TOMFragebogen.Baustein) {
    this.aufgeklappteIds = this.aufgeklappteIds.filter(
      (id) => id !== baustein.Id
    );
    this.aufgeklappteIds = this.aufgeklappteIds.filter((id) =>
      baustein.KinderIds.every((kindId) => id !== kindId)
    );
  }

  public onKlappen(baustein: TOMFragebogen.Baustein) {
    const istAufgeklappt = this.aufgeklappteIds.some(
      (id) => id === baustein.Id
    );

    if (istAufgeklappt) {
      this.klappeBausteinZu(baustein);

      if (baustein.Art === TOMFragebogen.Baustein.Art.Ueberschrift1Ordnung) {
        this.aufgeklappteIds =
          TOMFragebogen.Logic.getIdsWithAtleastOneOfKindOpen(
            this.fakeFragebogen.TomBausteine,
            this.aufgeklappteIds,
            baustein
          );
      }
    } else {
      if (baustein.Art === TOMFragebogen.Baustein.Art.Ueberschrift1Ordnung) {
        // Nur eine Überschrift soll geöffnet sein während der Bearbeitung/Auswahl
        this.aufgeklappteIds = [];
      }

      this.aufgeklappteIds = [...this.aufgeklappteIds, baustein.Id];

      this.aufgeklappteIds = [
        ...this.aufgeklappteIds,
        ...TOMFragebogen.Logic.getAllParentIds(baustein),
      ];
    }
  }

  public async save(shouldRedirectToDokumente?: boolean) {
    try {
      // if (
      //   this.fakeFragebogen.TomBausteine.every(
      //     (c) => c.IstAusgewaehlt === false || c.IstAusgewaehlt === undefined
      //   )
      // ) {
      //   this.errors.add({ field: "Aufstellung", msg: "Aufstellung" });
      //   console.error(
      //     "nichts ausgewählt?",
      //     this.fakeFragebogen.TomBausteine.filter((c) => c.IstAusgewaehlt),
      //     this.aufstellung.TomBausteine.filter((c) => c.IstAusgewaehlt)
      //   );
      // } else {
      //   this.errors.remove("Aufstellung");
      // }

      this.errors.removeById("DokumentBezeichnung");
      if (this.aufstellung.Bezeichnung === "") {
        this.errors.add({
          field: "Dokument.Bezeichnung",
          msg: "Bezeichnung",
          id: "DokumentBezeichnung",
        });
      }

      this.hasTriedSaving = true;
      this.aufstellung.TomBausteine = this.fakeFragebogen.TomBausteine;
      await this.$validator.validateAll();
      if (this.errors.count() == 0) {
        try {
          this.isSending = true;
          this.isDirty = false;
          const erstellteAufstellungId =
            await this.tomfApi.AufstellungErstellen(this.aufstellung);

          GlobalHelper.NotifySuccess();
          if (shouldRedirectToDokumente) {
            this.$router.push("/dokument");
          } else {
            const searchParams = new URLSearchParams();
            searchParams.set("mode", TOMFragebogen.Modus.Auswahl.toString());
            searchParams.set("aufgeklappt", this.aufgeklappteIds.join(","));
            const query = searchParams.toString();

            this.$router.push(
              `/dokument/tomfragebogen/aufstellung/${erstellteAufstellungId}?${query}`
            );
          }
        } finally {
          this.isSending = false;
        }
      } else {
        if (this.errors.items) {
          this.errors.items.forEach((error) => console.error(error));
        }
        GlobalHelper.NotifyError(
          this.$t("Allgemein.Pflichtfeld nicht ausgefüllt.").toString()
        );
        return Promise.reject();
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  public async onSubmit(event: Event) {
    try {
      event.preventDefault();

      await this.save(true);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  @Watch("erstellungDatum", { deep: true })
  public updateErstellung(value: Date) {
    if (this.aufstellung) {
      this.aufstellung.Erstellung = DateTime.fromJSDate(value).toUTC().toISO();
    }
  }

  public toggleFragebogen() {
    this.prepareAufgeklappteForAuswahl();
    this.isDisplayingFragebogen = !this.isDisplayingFragebogen;
  }

  public async loadTomFragebogen() {
    try {
      const response = await this.tomfApi.GetHauptFragebogen();
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  public prepareAufgeklappteForAuswahl(mode?: TOMFragebogen.Modus) {
    this.fakeFragebogen.TomBausteine = this.fakeFragebogen.TomBausteine.map(
      (c) => {
        c[TOMFragebogen.Baustein.Symbols.istAngepasst] = false;
        c[TOMFragebogen.Baustein.Symbols.istAufgeklappt] = false;
        return c;
      }
    );

    this.aufgeklappteIds = [];

    const kapitel = TOMFragebogen.Logic.getAllElementsOfKind(
      this.fakeFragebogen.TomBausteine,
      TOMFragebogen.Baustein.Art.Kapitel
    );

    const firstKapitel = kapitel[0];
    if (firstKapitel) this.aufgeklappteIds.push(firstKapitel.Id);
    if (firstKapitel.KinderIds.length)
      this.aufgeklappteIds.push(firstKapitel.KinderIds[0]);
  }

  public async initialise() {
    try {
      const hauptFragebogen = await this.loadTomFragebogen();

      const clone = (window as any).structuredClone(hauptFragebogen);
      const filled = TOMFragebogen.Logic.fillSymbolsFragebogen(clone);
      this.fakeFragebogen = filled;

      this.aufstellung = TOMFragebogen.Logic.createAufstellung(
        this.fakeFragebogen,
        this.userStore.currentKundeId
      );

      const initialesDatum = DateTime.fromISO(new Date().toISOString())
        .toUTC()
        .toJSDate();
      this.erstellungDatum = initialesDatum;
      this.updateErstellung(initialesDatum);

      this.prepareAufgeklappteForAuswahl();

      return;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  formatter(date: Date) {
    return DateHelpers.PickerFormatter(date);
  }

  get dplang(): any {
    return this.$i18n.locale.toString().toLowerCase() == "de"
      ? pickerlanguages.de
      : pickerlanguages.en;
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.isDisplayingFragebogen) this.toggleFragebogen();
    if (this.isDirty) {
      confirmDeletion(
        this.$t("Nicht gespeicherte Änderungen"),
        this.$t(
          "Sie haben nicht gespeicherte Änderungen auf dieser Seite - Möchten Sie die Seite verlassen und die Änderungen verwerfen?"
        ),
        this.$t("Ohne speichern verlassen"),
        this.$t("Abbrechen"),
        () => {
          next(true);
        },
        () => {
          next(false);
        }
      );
    } else {
      next(true);
    }
  }

  async mounted() {
    await this.initialise();
    this.isLoading = false;
  }
}
